// extracted by mini-css-extract-plugin
export default {"page":"PricesPage_page__GiGio","content":"PricesPage_content__4AFqk"};